import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateService } from '../../../shared/services/date.service';

@Component({
  standalone: false,
  selector: 'app-view-transaction',
  templateUrl: './view-transaction.component.html',
  styleUrl: './view-transaction.component.scss'
})
export class ViewTransactionComponent {

  @Input() transactionData: any;

  constructor(private activeModal: NgbActiveModal,
    private _date: DateService
  ) {

  }

  ngOnInit() {
    console.log(this.transactionData);
  }

  onClose() {
    const vm = this;
    vm.activeModal.close(true);
  }
   
 get transactionAmount() {
    try {
      const conversions = JSON.parse(this?.transactionData?.conversions);
      return conversions.customerPays.currency+' '+conversions.customerPays.amount;
    } catch (e) {
      return '0';
    }
  }

  dateFormat(value: any) {
    const vm = this;
    return vm._date.getFormattedDateWithAMPM(value);
  }

  getLatLongFromLocation(value: string) {
    if (!value) return '-';
    try {
      const loc = (JSON.parse(value));


      if (loc.coords) {
        const latitude = loc.coords.latitude;
        const longitude = loc.coords.longitude;
        return latitude + ', ' + longitude;
      }
      return '-';
    } catch (e) {
      return '-';
    }
  }

}
